module.exports = __webpack_public_path__ + "img/q3.96d9330b.png";